import { useState } from "react";
import { Button } from "../components/ui/button.js";
import { Card, PageHeader } from "../components/ui/card.js";
import { SelectInput, TextInput } from "../components/ui/field.js";
import { ReportTable } from "../components/report/reportTable.js";
import { downloadReportCsv } from "../lib/reportCsv.js";
import { useHasPermission } from "../lib/session.js";
import { REPORT_DEFS, useReport } from "../lib/useReport.js";
import { useI18n } from "../i18n/index.js";

export function ReportsPage() {
  const { t } = useI18n();
  const canFinancial = useHasPermission("reports:financial");
  const defs = REPORT_DEFS.filter((d) => !d.financial || canFinancial);

  const [name, setName] = useState(defs[0]?.name ?? "quote-conversion");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const { data, loading, error } = useReport(name, from, to);
  const selectedDef = defs.find((d) => d.name === name);
  const caption = selectedDef ? t(selectedDef.labelKey) : name;

  return (
    <>
      <PageHeader
        title={t("nav.reports")}
        description={t("reports.description")}
        actions={
          <Button
            variant="secondary"
            onClick={() => void downloadReportCsv(name, from, to)}
            disabled={!data || data.rows.length === 0}
          >
            {t("reports.downloadCsv")}
          </Button>
        }
      />

      <Card className="mb-4">
        <div className="grid gap-3 sm:grid-cols-3">
          <SelectInput
            label={t("reports.report")}
            options={defs.map((d) => ({ value: d.name, label: t(d.labelKey) }))}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextInput
            label={t("common.fields.from")}
            type="date"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
          />
          <TextInput
            label={t("common.fields.to")}
            type="date"
            value={to}
            onChange={(e) => setTo(e.target.value)}
          />
        </div>
      </Card>

      <ReportTable report={data} caption={caption} loading={loading} error={error} />
    </>
  );
}
